export type SupportedLocales = 'en' | 'de' | 'fr' | 'nl' | 'sv' | 'fi' | 'es' | 'it' | 'pt';

type WebappTranslationImports = {
  [Key in SupportedLocales]: () => Promise<{ [k in Key]: Record<string, any> }>;
};

export const tellentReportsTranslations: WebappTranslationImports = {
  en: () =>
    import('./en.json').then(translations => ({
      en: translations.default,
    })),
  de: () =>
    import('./de.json').then(translations => ({
      de: translations.default,
    })),
  fr: () =>
    import('./fr.json').then(translations => ({
      fr: translations.default,
    })),
  nl: () =>
    import('./nl.json').then(translations => ({
      nl: translations.default,
    })),
  sv: () =>
    import('./sv.json').then(translations => ({
      sv: translations.default,
    })),
  fi: () =>
    import('./fi.json').then(translations => ({
      fi: translations.default,
    })),
  es: () =>
    import('./es.json').then(translations => ({
      es: translations.default,
    })),
  it: () =>
    import('./it.json').then(translations => ({
      it: translations.default,
    })),
  pt: () =>
    import('./pt.json').then(translations => ({
      pt: translations.default,
    })),
};
